
export default function EventLicensesSection() {
  return (
    <section className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/29c705c04d7055687b27f477f6c0a5a4.jpeg"
                alt="Licenças para Eventos e Espaços Temporários"
                className="w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#5C1A24]/20 to-transparent"></div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#5C1A24] rounded-full flex items-center justify-center mr-4">
                <i className="ri-calendar-event-line text-white text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24]" style={{ fontFamily: '"Playfair Display", serif' }}>
                Licenças para Eventos e Espaços Temporários
              </h2>
            </div>
            
            <div className="text-[#3F3F3F] leading-relaxed space-y-4">
              <p>
                Emitimos laudos, plantas e documentos técnicos exigidos por prefeituras e bombeiros, com rapidez e precisão.
              </p>
              <p>
                Em um único mês, liberamos mais de 10 eventos — todos dentro do prazo e com segurança total.
              </p>
              <p className="font-medium text-[#5C1A24]">
                Eventos prontos para acontecer, sem imprevistos ou atrasos.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                'Laudos técnicos',
                'Plantas de eventos',
                'Aprovações rápidas',
                'Segurança garantida'
              ].map((feature, index) => (
                <div key={index} className="flex items-center">
                  <i className="ri-check-line text-[#5C1A24] mr-2"></i>
                  <span className="text-sm text-[#3F3F3F]">{feature}</span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="mt-8 bg-white p-6 rounded-xl shadow-lg">
              <div className="grid grid-cols-2 gap-4 text-center">
                <div>
                  <div className="text-2xl font-bold text-[#5C1A24]">10+</div>
                  <div className="text-sm text-[#3F3F3F]">Eventos por mês</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#5C1A24]">100%</div>
                  <div className="text-sm text-[#3F3F3F]">No prazo</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
